import { Component, Input, TemplateRef, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
  selector: 're-tree-panel',
  template: "\n    <ul class=\"list-unstyled\"><li reTreeNode *ngFor=\"let node of treeData\" [node]=\"node\" [textField]=\"textField\" [valueField]=\"valueField\" [iconField]=\"iconField\" [nodeCssClass]=\"nodeCssClass\" [checkable]=\"checkable\" [lazyLoad]=\"lazyLoad\" [loadingIcon]=\"loadingIcon\" [loadChildren]=\"loadChildren\" [allowDraggable]=\"allowDraggable\" [nodeItemTemplate]=\"nodeItemTemplate\" [nodeItemToolbarTemplate]=\"nodeItemToolbarTemplate\" [leafIcon]=\"leafIcon\" [expendIcon]=\"expendIcon\" [collapseIcon]=\"collapseIcon\" [allowMutipleSelected]=\"allowMutipleSelected\" [parentNode]=\"parentNode\"></li></ul>\n  "
})
export class TreePanelComponent {
  @Input() treeData: any[];
  @Input() parentNode: any;
  @Input() valueField;
  @Input() textField;
  @Input() nodeCssClass: string;
  @Input() iconField: string;
  @Input() checkable = false;
  @Input() lazyLoad = false;
  @Input() loadingIcon: string;
  @Input() loadChildren: (parent: any) => Observable<any[]>;
  @Input() allowDraggable = false;
  @Input() allowMutipleSelected = false;
  @Input() nodeItemTemplate: TemplateRef<any>;
  @Input() nodeItemToolbarTemplate: TemplateRef<any>;
  @Input() leafIcon;
  @Input() expendIcon;
  @Input() collapseIcon;
  @Output() nodeItemCheckedChanged = new EventEmitter<any>();


  onNodeItemCheckedChanged(node) {
    this.nodeItemCheckedChanged.emit(node);
  }
}
